/**
* 欢迎来到墨子工程
* 邮箱: duheng1100@163.com
* github: https://github.com/duheng/
**/
'use strict';

var vuex_esmBundler = require('./vuex.esm-bundler-607ad4c2.js');
require('./es.number.constructor-17a0e7eb.js');
var normalizeComponent = require('./normalize-component-d885d5ff.js');

var __nuxt = process && !!process.env.isNuxt;
var __mapState = __nuxt ? vuex_esmBundler.mapState({
  theme: function theme(state) {
    return state.theme;
  },
  colors: function colors(state) {
    return state.colors;
  }
}) : vuex_esmBundler.mapState({
  theme: function theme(state) {
    return state.common.theme;
  },
  colors: function colors(state) {
    return state.common.colors;
  }
});
var script = {
  name: "LayPopup",
  data: function data() {
    return {
      visible: false,
      list: []
    };
  },
  computed: vuex_esmBundler._objectSpread2({}, __mapState),
  props: {
    center: {
      type: Boolean,
      require: true,
      default: true
    },
    title: {
      type: String,
      require: false,
      default: ""
    },
    isphone: {
      type: Boolean,
      require: false,
      default: false
    },
    closeBtn: {
      type: Boolean,
      require: true,
      default: true
    },
    maskClose: {
      type: Boolean,
      require: false,
      default: false
    },
    modal: {
      type: Boolean,
      require: false,
      default: true
    },
    drawerRadius: {
      type: Boolean,
      require: false,
      default: true
    },
    size: {
      type: String,
      require: false,
      default: "80%"
    },
    appendBody: {
      type: Boolean,
      require: false,
      default: false
    },
    width: {
      type: Number,
      require: false,
      default: 560
    }
  },
  methods: {
    open: function open() {
      var _this = this;
      this.$nextTick(function () {
        _this.visible = true;
      });
    },
    close: function close() {
      var _this2 = this;
      this.$nextTick(function () {
        _this2.visible = false;
        _this2.$emit("closeCallBack");
      });
    }
  }
};

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.isphone
    ? _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.visible,
            modal: _vm.modal,
            "before-close": _vm.close,
            size: _vm.size,
            center: _vm.center,
            direction: "btt",
            "custom-class": [
              "background-1 cube",
              _vm.theme,
              _vm.drawerRadius ? "drawer-btt" : "drawer-btt no-radius",
            ].join(" "),
            wrapperClosable: _vm.maskClose,
            "append-to-body": _vm.appendBody,
            "modal-append-to-body": _vm.appendBody,
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event;
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "lay-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              !_vm.title
                ? _vm._t("title")
                : _c("div", [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _vm.closeBtn
                ? _c("img", {
                    staticClass: "move_down",
                    attrs: {
                      src: require("~/assets/img/drawer_close_" +
                        _vm.theme +
                        ".png"),
                    },
                    on: { click: _vm.close },
                  })
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      )
    : _c(
        "el-dialog",
        {
          class: { width400: _vm.width === 400 },
          attrs: {
            "show-close": false,
            title: _vm.title,
            visible: _vm.visible,
            modal: _vm.modal,
            "before-close": _vm.close,
            "custom-class": ["background-1", "lay-dialog", _vm.theme].join(" "),
            "close-on-click-modal": _vm.maskClose,
            "append-to-body": _vm.appendBody,
            "modal-append-to-body": _vm.appendBody,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event;
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "lay-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              !_vm.title
                ? _vm._t("title")
                : _c(
                    "div",
                    {
                      staticClass: "background-1",
                      class: [
                        _vm.width === 400
                          ? "text-style-body-400"
                          : "text-style-h-4-400",
                      ],
                    },
                    [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]
                  ),
              _vm._v(" "),
              _vm.closeBtn
                ? _c("img", {
                    staticClass: "move_down",
                    attrs: {
                      src: require("./img/drawer_close_" + _vm.theme + ".png"),
                    },
                    on: { click: _vm.close },
                  })
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-a7599bc0";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent.normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

exports.__vue_component__ = __vue_component__;
